import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth-store'
import { Loader2 } from 'lucide-react'

interface PublicRouteProps {
  children: React.ReactNode
}

/**
 * PublicRoute - Wrapper for routes that should only be accessible to unauthenticated users
 * Per DEMO-ROADMAP.md Milestone 2.3:
 * - Redirects authenticated users to dashboard
 * - Shows loading state during initial auth check
 * - Used for login, forgot password, etc.
 */
export function PublicRoute({ children }: PublicRouteProps) {
  const { isAuthenticated, isInitialized } = useAuthStore()

  // Show loading spinner while checking auth state
  if (!isInitialized) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-sm text-muted-foreground">Loading...</p>
        </div>
      </div>
    )
  }

  // Redirect to dashboard if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
